import React, { Component } from 'react'
import { compose } from 'react-apollo'
import Styled from 'styled-components'
import { connect } from 'react-redux'

import {
  createProjectState,
  destroyProjectState
} from 'actions/project'

import { withRouter, Switch, Route, Redirect } from 'router/index'

import PageLoader from 'components/PageLoader'
import NotFound from 'components/NotFound'
import ProjectNavigation from 'components/ProjectNavigation'
import Editor from 'components/Editor'
import Theme from 'components/Theme'
import Settings from 'components/Settings'
import Preview from 'components/Preview'

import {
  project as projectQuery
} from 'components/Project/queries'

const Main = Styled.div`
  height: calc(100% - 4.5rem);
  width: 100vw;
  overflow: hidden;
`

class Project extends Component {
  componentDidUpdate() {
    if (this.props.loading && !this.props.data.loading) {
      this.props.createProjectState({
        project: this.props.data.project,
        components: this.props.data.components,
        integrations: this.props.data.integrations
      })
    }
  }

  componentWillUnmount() {
    this.props.destroyProjectState()
  }

  render() {
    if (this.props.notFound) {
      return <NotFound />
    }

    return (
      <React.Fragment>
        <ProjectNavigation />

        <Main>
          {this.props.loading &&
            <PageLoader />
          }

          {!this.props.loading &&
            <Switch>
              <Route path={`${this.props.match.path}/editor`} component={Editor} />
              <Route path={`${this.props.match.path}/theme`} component={Theme} />
              <Route path={`${this.props.match.path}/settings`} component={Settings} />
              <Route path={`${this.props.match.path}/preview`} component={Preview} />

              <Redirect path={`${this.props.match.path}`} to={`${this.props.match.path}/editor`} />
            </Switch>
          }
        </Main>
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createProjectState: ({ project, components, integrations }) => dispatch(createProjectState({ project, components, integrations })),
    destroyProjectState: () => dispatch(destroyProjectState())
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.project.loading
  }
}

export default withRouter(compose(
  projectQuery
)(connect(mapStateToProps, mapDispatchToProps)(Project)))



// WEBPACK FOOTER //
// ./src/components/Project/index.js